import type { KeyboardEvent } from "react";

/**
 * Spreadable keyboard handler for non-button elements that already carry an
 * `onClick`. Triggers the same click handler on Enter/Space, satisfying
 * WCAG 2.1.1 (Keyboard) without duplicating the click logic.
 *
 * @example
 *   <div onClick={open} role="button" tabIndex={0} onKeyDown={onActivate}>…</div>
 *
 * Always pair with `role="button"` (or appropriate role) and `tabIndex={0}`.
 */
export function onActivate(e: KeyboardEvent<HTMLElement>) {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    e.currentTarget.click();
  }
}
